<template>
  <div class="signedin-layout">
    <v-app-bar
      :clipped-left="true"
      color="primary"
      dark
      dense
      app
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" style="width: 100px;" v-if="!isMobile">
        <v-icon>mdi-menu</v-icon>
        <span style="font-weight: bold; padding-top: auto; padding-bottom: auto;">
          メニュー
        </span>
      </v-app-bar-nav-icon>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="isMobile">
        <v-icon>mdi-menu</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>{{this.getCampaign.name}}</v-toolbar-title>
      <v-chip
        v-if="stageName"
        class="ma-2"
        :color="stageColor"
        text-color="white"
      >
        {{stageName}}
      </v-chip>
      <v-spacer></v-spacer>
      <News ref="news" @errorHandling="errorHandling"/>
      <User :userviewInfo="userInfo" @errorHandling="errorHandling"/>
    </v-app-bar>

    <v-navigation-drawer
      :clipped="true"
      v-model="drawer"
      app
      v-if="this.emailVerified"
    >
      <v-list>
        <template v-for="(menu, index) in menuOptionList">
          <v-list-item
            v-if="(typeof menu.items !== 'object')"
            :key="index"
            :to="`/${menu.link}`"
            v-show="checkLinkStatus(menu.link)"
            link
          >
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ menu.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group
            v-else
            :prepend-icon="menu.icon"
            :key="index"
            :value="false"
            v-show="checkLinkStatus(menu.link)"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="menu.title" />
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(childPage, cIndex) in menu.items"
              :key="cIndex"
              :to="`/${childPage.link}`"
              link
              :target="childPage.target"
            >
              <v-list-item-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="childPage.title" />
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        <v-list-item
          v-if="checkLinkStatus('continue')"
          @click="changeCampaign()"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-run-fast</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>継続版</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="checkLinkStatus('normal')"
          @click="changeCampaign()"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-undo-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>通常版</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider v-if="checkLinkStatus('manage')"></v-divider>
      <v-list>
        <v-list-item
          v-if="checkLinkStatus('manage')"
          :to="`/manage`"
          link
        >
          <v-list-item-icon>
            <v-icon>mdi-account-key</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>管理者画面</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-container class="pa-sm-6" fluid>
        <router-view
          :key="mainContentKey"
          :campaignUser="campaignUser"
          :courseRanking="propCourseRank"
          @fetchCampaignUser='fetchCampaignUser'
          @fetchChangeEmail='fetchChangeEmail'
          @fetchChangeSeconded='fetchUserViewData'
          @errorHandling="errorHandling" />
      </v-container>
    </v-main>

    <v-footer
      :absolute="false"
      outlined
      padless
      elevation="1"
      color="white"
      app
      style="font-size:0.8rem"
    >
      <v-spacer></v-spacer>
      健康チャレンジキャンペーン<span style="font-size:0.5rem">©®</span>
      <v-spacer></v-spacer>
    </v-footer>

    <!--エラー-->
    <div>
      <v-overlay :value="isError" :absolute="true"></v-overlay>
      <v-snackbar :timeout="-1" color="red" outlined v-model="isError" top>
        <div style="font-weight: bold;">システムエラー：{{errorMessage}}</div>
        <template v-slot:action="{ attrs }">
          <v-btn
            v-bind="attrs"
            @click="isError = false"
            color="error"
            outlined
          >
            閉じる
          </v-btn>
        </template>
      </v-snackbar>
      <Dialog ref="confirm"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import GraphqlAPI from '../utils/GraphqlAPI'
import dayjs from 'dayjs'
import Theme from '../utils/Theme'
const News = () => import('../views/news/News.vue')
const User = () => import('../views/user/User.vue')
const Dialog = () => import('../views/util/Dialog.vue')

const listCourseRankingQuery = (campaignId) => `
  query getlistCourseRanking {
    listCourseRanking(campaign_id: "${campaignId}") {
      ranking {
        course {
          name
          participants
        }
        rank
      }
    }
  }
`
const fetchListCourseRanking = async (campaignId) => {
  const { data: { listCourseRanking: data } } = await GraphqlAPI(listCourseRankingQuery(campaignId))
  return {
    ranking: data.ranking.map((item) => {
      return {
        rank: item.rank,
        name: item.course.name,
        participants: item.course.participants
      }
    })
  }
}

const getCampaignUserQuery = (campaignId) => `
  query getCampaignUser {
    getCampaignUser(campaign_id: "${campaignId}") {
      id
      total_point
      is_prizewinner
      course
      custom_objective_list {
        course_id
        custom_objective
      }
    }
  }
`

const getCampaignUser = async (campaignId) => {
  const { data: { getCampaignUser: data } } = await GraphqlAPI(getCampaignUserQuery(campaignId))
  return data
}

const getUserViewQuery = (campaignId) => `
  query getUserView {
    getUserView(campaign_id: "${campaignId}") {
      is_manager
      certificate_number
      user_classification
      email
    }
  }
`
const getUserViewInfo = async (campaignId) => {
  const { data: { getUserView: data } } = await GraphqlAPI(getUserViewQuery(campaignId))
  return {
    is_manager: data.is_manager,
    certificate_number: data.certificate_number,
    user_classification: data.user_classification,
    email: data.email
  }
}

const generateUsersMutation = (campaignId) => `
  mutation generateUsers {
    generateUsers(campaign_id: "${campaignId}")
  }
`
const generateUsers = async (campaignId) => {
  const { data: { generateUsers: data } } = await GraphqlAPI(generateUsersMutation(campaignId))
  return data
}

const checkAppUserStatusQuery = (campaignId) => `
  query checkAppUserStatus {
    checkAppUserStatus (campaign_id: "${campaignId}")
  }
`
const checkAppUserStatus = async (campaignId) => {
  const { data: { checkAppUserStatus: data } } = await GraphqlAPI(checkAppUserStatusQuery(campaignId))
  return data
}

const checkExistCampaignUserQuery = (campaignId) => `
  query {
    checkExistCampaignUser (
        campaign_id: "${campaignId}"
    ) {
        is_exist
    }
  }
`
const checkExistCampaignUser = async (campaignId) => {
  const { data: { checkExistCampaignUser: data } } = await GraphqlAPI(checkExistCampaignUserQuery(campaignId))
  return data
}

// 達成賞対象ユーザーリストの取得
const getPrizeUserCode = (campaignId) => `
  query getPrizeUserCode {
    getPrizeUserCode(campaign_id: "${campaignId}") {
      prize_user {
        id
      }
      prize_code
    }
  }
`
const getPrizeUserCodeQuery = async (campaignId) => {
  const { data: { getPrizeUserCode: data } } = await GraphqlAPI(getPrizeUserCode(campaignId))
  return data
}

export default Vue.extend({
  name: 'MainLayout',
  components: { News, User, Dialog },
  mixins: [Theme],
  data () {
    return {
      pageType: 'Layout',
      campaignUser: {},
      isExist: false,
      menuOptionList: [
        { link: 'result', title: '記録', icon: 'mdi-lead-pencil' },
        { link: 'question', title: 'アンケート', icon: 'mdi-checkbox-marked-outline' },
        { link: 'team', title: 'チーム情報', icon: 'mdi-account-group' },
        { link: 'board', title: '掲示板', icon: 'mdi-bulletin-board' },
        { link: 'process_participation', title: '参加手順', icon: 'mdi-information' },
        { link: 'course', title: 'コース設定', icon: 'mdi-cog-outline' },
        { link: 'process_course', title: 'コース説明', icon: 'mdi-book-open-variant' },
        {
          title: 'コース',
          icon: 'mdi-clipboard-outline',
          link: 'course_menu_option',
          items: [
            { link: 'process_participation', title: '参加手順', target: '' },
            { link: './manual/course_detail.pdf', title: 'チャレンジ冊子', target: '_blank' },
            { link: 'course', title: 'コース設定', target: '' },
            { link: 'process_course', title: 'コース説明', target: '' }
          ]
        },
        { link: 'learning', title: 'e-Learning・講演会', icon: 'mdi-movie-play' },
        { link: 'prize', title: '達成賞', icon: 'mdi-medal-outline' }
      ],
      userInfo: {},
      manageFlg: false,
      mainContentKey: null,
      propCourseRank: [],
      drawer: null,
      isError: false,
      errorMessage: null,
      emailVerified: false,
      isShowPrize: false
    }
  },
  props: {
    options: {
      type: Array,
      default: () => [
      ]
    }
  },
  computed: {
    getCampaign () {
      return this.$store.getters.getCampaign
    },
    getRelationalCampaign () {
      return this.$store.getters.getRelationalCampaign
    },
    getEmailVerified () {
      return this.$store.getters.getEmailVerified
    },
    getRegisteredCourse () {
      return this.$store.getters.getRegisteredCourse
    },
    isAppEntered () {
      const appEntryStatus = this.$store.getters.getAppEntryStatus
      if (appEntryStatus === 'Temporary' || appEntryStatus === 'Waiting' || appEntryStatus === 'Completion') {
        return true
      }
      return false
    },
    isQuestionPeriod () {
      const startDate = dayjs(this.getCampaign.questionnaire_start, 'YYYY-MM-DD')
      const endDate = dayjs(this.getCampaign.questionnaire_end, 'YYYY-MM-DD').add(1, 'days')
      if (this.getCampaign.is_questionnaire && startDate <= dayjs() && dayjs() < endDate) {
        return true
      } else {
        return false
      }
    },
    isContinueCampaign () {
      // 継続版判定
      const isContinuity = this.getCampaign.is_continuity
      const continuityOpen = this.getRelationalCampaign.site_open
      const continuityOpenDate = dayjs(this.getRelationalCampaign.site_open, 'YYYY-MM-DD')
      if (!isContinuity && continuityOpen && continuityOpenDate && continuityOpenDate <= dayjs()) {
        return true
      } else {
        return false
      }
    },
    isNormalCampaign () {
      // 通常盤判定
      const isContinuity = this.getCampaign.is_continuity
      if (isContinuity && this.isExist) {
        return true
      } else {
        return false
      }
    },
    stageName () {
      // prodは表示しない
      if (process.env.VUE_APP_DISP_STAGE_NAME === 'prod') {
        return null
      }
      return process.env.VUE_APP_DISP_STAGE_NAME
    },
    stageColor () {
      return process.env.VUE_APP_DISP_STAGE_COLOR
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  async created () {
    if (!this.getCampaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    this.emailVerified = this.getEmailVerified
    this.checkShowPrize()
    this.fetchRankingList()
    this.fetchRelationalCampaignUser()
    this.$vuetify.theme.themes.light = this.$_getTheme(this.getCampaign.is_continuity)
    this.fetchCampaignUser()
    this.fetchUserViewData()
    this.mainContentKey = this.getCampaign.id
  },
  methods: {
    async fetchRankingList () {
      try {
        const rankingResult = await fetchListCourseRanking(this.getCampaign.id)
        this.propCourseRank = rankingResult.ranking
      } catch (e) {
        this.errorHandling('コースランキングの取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async fetchCampaignUser () {
      try {
        this.campaignUser = await getCampaignUser(this.getCampaign.id)
        const customObjectiveList = this.campaignUser.custom_objective_list
        if (customObjectiveList.length > 0) {
          this.$store.dispatch('setRegisteredCourse', true)
        } else {
          this.$store.dispatch('setRegisteredCourse', false)
        }
      } catch (e) {
        this.errorHandling('ユーザーの取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async fetchUserViewData () {
      try {
        this.userInfo = await getUserViewInfo(this.getCampaign.id)
        this.manageFlg = this.userInfo.is_manager
      } catch (e) {
        this.errorHandling('ユーザーの取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async fetchRelationalCampaignUser () {
      try {
        const checkExistObj = await checkExistCampaignUser(this.getRelationalCampaign.id)
        this.isExist = checkExistObj.is_exist
      } catch (e) {
        this.errorHandling('ユーザーの取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async checkShowPrize () {
      const isPrizeSendPeriod = dayjs() > dayjs(this.getCampaign.prize_mail_send_date, 'YYYY-MM-DD')
      if (isPrizeSendPeriod) {
        const prizeUser = await getPrizeUserCodeQuery(this.getCampaign.id)
        if (prizeUser && prizeUser.prize_code) {
          this.isShowPrize = true
        } else {
          this.isShowPrize = false
        }
      } else {
        this.isShowPrize = true
      }
    },
    checkLinkStatus (LinkType) {
      switch (LinkType) {
        case 'result':
          return this.getRegisteredCourse || this.isAppEntered
        case 'course':
          return !(this.getRegisteredCourse || this.isAppEntered)
        case 'team':
          return this.getCampaign.is_team && this.getRegisteredCourse
        case 'board':
          return this.getCampaign.is_board && (this.getRegisteredCourse || this.isAppEntered)
        case 'process_participation':
          return !(this.getRegisteredCourse || this.isAppEntered)
        case 'process_course':
          return !(this.getRegisteredCourse || this.isAppEntered)
        case 'question':
          return this.isQuestionPeriod && this.getRegisteredCourse
        case 'continue':
          return this.isContinueCampaign
        case 'normal':
          return this.isNormalCampaign
        case 'manage':
          return this.manageFlg && !this.getCampaign.is_continuity
        case 'learning':
          return this.getCampaign.is_learning
        case 'prize':
          return this.getCampaign.is_prize_select && this.isShowPrize
        case 'course_menu_option':
          return this.getRegisteredCourse || this.isAppEntered
      }
    },
    async changeCampaign () {
      let confirmFlg = false
      if (!this.isExist) {
        let msg
        if (this.getCampaign.is_prize) {
          msg = '「継続版（達成賞なし）」の画面に遷移しますが、よろしいですか？<br/>（<span class="red--text font-weight-bold">達成賞の確認は「通常版」に切り替え</span>てください）'
        } else {
          msg = '「継続版」の画面に遷移しますが、よろしいですか？'
        }
        confirmFlg = await this.$refs.confirm.open(null, msg)
      }
      if (this.isExist || confirmFlg) {
        try {
          if (!this.getCampaign.is_continuity) {
            await generateUsers(this.getCampaign.relational_campaign_id)
          }
          await this.$store.dispatch('changeCampaign')
          await this.fetchCampaignUser()
          this.drawer = false
          this.$vuetify.theme.themes.light = this.$_getTheme(this.getCampaign.is_continuity)
          if (this.getCampaign.is_continuity) {
            this.fetchRelationalCampaignUser()
          }
          this.fetchRankingList()
          this.fetchUserViewData()
          this.checkShowPrize()
          if (this.getCampaign.is_app_challenge) {
            this.featchAppEntryStatus()
          }
          if (this.getRegisteredCourse && this.$route.name !== 'result') {
            await this.$router.push('/result')
          } else if (!this.getRegisteredCourse && this.$route.name !== 'course') {
            await this.$router.push('/course')
          }
          this.mainContentKey = this.getCampaign.id
          await this.$refs.news.fetchListNews()
          if (this.$refs.news.hasUnread) {
            this.$refs.news.dialog = true
          }
        } catch (e) {
          this.errorHandling('継続版ユーザーの作成に失敗しました。' + e.errors[0].message)
          this.$log.debug(e)
        }
      }
    },
    fetchChangeEmail () {
      this.emailVerified = this.getEmailVerified
    },
    async featchAppEntryStatus () {
      try {
        const appEntryStatus = await checkAppUserStatus(this.getCampaign.id)
        this.$store.dispatch('setAppEntryStatus', appEntryStatus)
      } catch (e) {
        this.$log.debug(e)
      }
    },
    errorHandling (message) {
      this.isError = true
      this.errorMessage = message
    }
  }
})
</script>
